import {
  createBlankStarterInUserStorage,
  type CreatedBlankStarterFile,
  type MyAppsWorkspaceStarterId
} from '../fileBrowser/createBlankStarterInUserStorage';
import { readDefaultContentFolderPath } from '../fileBrowser/defaultContentFolderPrefs';
import type { MountSummary } from '../fileBrowser/fileBrowserApi';
import { isUserStorageMount } from '../storageFileAudit/formatters';

/**
 * Creates a blank Workspace starter file somewhere the user can write: their default
 * content folder in My Storage when the site provisions it, otherwise a ReadWrite mount root.
 */
export async function createBlankStarterOnWritableMount(
  starterId: MyAppsWorkspaceStarterId,
  writableMounts: readonly MountSummary[]
): Promise<CreatedBlankStarterFile> {
  const userStorage = writableMounts.find((mount) => isUserStorageMount(mount.id));
  const target = userStorage ?? writableMounts[0];
  if (!target) {
    throw new Error('You do not have write access to any storage location.');
  }
  return createBlankStarterInUserStorage(
    starterId,
    target.id,
    undefined,
    userStorage ? readDefaultContentFolderPath() : ''
  );
}
